// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"197":"40e2a343","466":"b92963e3","787":"e6766b5e","968":"2e986845"}[chunkId] + ".chunk.js";
};